import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
    return (
        <footer className={styles.Footer}>Brought to you by MEOW.</footer>
    );
};

export default Footer;
